export default __webpack_public_path__ + "static/media/006-helmet.d33aaaeb.png";